import React from 'react';
import { DownloadIcon } from 'lucide-react';
import { trackAddToCart } from '../../lib/metaPixel';
interface CTAButtonProps {
  className?: string;
  showReassurance?: boolean;
  fullWidth?: boolean;
  checkout?: boolean;
}
export function CTAButton({
  className = '',
  showReassurance = true,
  fullWidth = false,
  checkout = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (checkout) {
      trackAddToCart();
      window.location.href = 'https://wiselicecontrol.com/cart/43850281549890:1';
    } else {
      document.getElementById('oferta')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className={`flex flex-col items-center ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-278">
      <button className={`
          group relative flex items-center justify-center gap-2 
          bg-teal-600 hover:bg-teal-700 text-white 
          font-bold text-lg md:text-xl py-4 px-8 rounded-lg 
          shadow-[0_4px_0_rgb(15,118,110)] hover:shadow-[0_2px_0_rgb(15,118,110)] hover:translate-y-[2px]
          transition-all duration-200 active:shadow-none active:translate-y-[4px]
          ${fullWidth ? 'w-full' : 'w-full sm:w-auto'}
        `} onClick={handleClick} data-id="element-279">
        <DownloadIcon className="w-6 h-6 animate-bounce" data-id="element-280" />
        <span data-id="element-281">¡QUIERO EL PROTOCOLO AHORA!</span>
      </button>

      {showReassurance && <p className="mt-3 text-sm text-slate-500 flex items-center gap-1.5 font-medium text-center" data-id="element-282">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-283"></span>
          Acceso inmediato descargable incluso si son las 3 AM.
        </p>}
    </div>;
}